import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import NumberFormatTypes from './NumberFormatTypes';

const BTN_DEL = '⌫';
const BTN_CLEAR = 'C';
const BTN_CLOSE = '✘';
const BTN_OK = '✔';
const BTN_RESET = '↺';

const NumPad = (props) => {
  const [value, setValue] = useState(props.value);
  const { format, thousandSeparator, onChange } = props;

  const prefix = format === NumberFormatTypes.CURRENCY ? '$' : '';
  const suffix = format === NumberFormatTypes.PERCENT ? '%' : '';

  const getValueString = () => {
    return (value || 0).toFixed();
  };

  const buttonClicked = (e) => {
    const char = e.target.textContent;
    switch (char) {
      case BTN_CLEAR:
        setValue(null);
        break;
      case BTN_DEL:
        setValue(parseInt(getValueString().slice(0, -1)));
        break;
      case BTN_CLOSE:
        onChange(props.value);
        break;
      case BTN_OK:
        onChange(value);
        break;
      case BTN_RESET:
        setValue(props.value);
        break;
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        setValue(parseInt(getValueString() + char));
        break;
      default:
        break;
    }
  };

  const buttons = (labels) => {
    return (
      <div className="num-pad-component__row">
        {labels.map((l, i) => (
          <button key={i} onClick={buttonClicked}>
            {l}
          </button>
        ))}
      </div>
    );
  };

  return (
    <section className={props.className}>
      <div className="num-pad-component__header">{props.header}</div>
      <div className="num-pad-component__display">
        <NumberFormat
          className="num-pad-component__value"
          value={value}
          prefix={prefix}
          suffix={suffix}
          displayType="text"
          decimalScale={0}
          thousandSeparator={thousandSeparator}
        />
      </div>
      {buttons([7, 8, 9])}
      {buttons([4, 5, 6])}
      {buttons([1, 2, 3])}
      {buttons([BTN_CLEAR, 0, BTN_DEL])}
      {buttons([BTN_CLOSE, BTN_RESET, BTN_OK])}
    </section>
  );
};

NumPad.propTypes = {
  header: PropTypes.string,
  value: PropTypes.number,
  format: PropTypes.oneOf([
    NumberFormatTypes.NUMBER,
    NumberFormatTypes.CURRENCY,
    NumberFormatTypes.PERCENT,
  ]),
  onChange: PropTypes.func,
};

export default NumPad;
